import * as Sentry from '@sentry/react'
import axios from 'axios'
import { isProductionLikeEnvironment } from './runtime-environment'

const isAbortError = (error) =>
  axios.isCancel?.(error) ||
  error?.name === 'CanceledError' ||
  error?.name === 'AbortError' ||
  error?.code === 'ERR_CANCELED'

export const reportError = (error, { extra, tags, fingerprint } = {}) => {
  if (!isProductionLikeEnvironment) return
  if (!error || isAbortError(error)) return

  Sentry.captureException(error, {
    extra,
    tags,
    fingerprint
  })
}

export default reportError
